
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nominate",
      function () {
        return require("private-next-pages/nominate/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nominate"])
      });
    }
  